import { render, staticRenderFns } from "./Cars.vue?vue&type=template&id=28ded4b4"
import script from "./Cars.vue?vue&type=script&lang=ts"
export * from "./Cars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports